import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const EditMeetingIcon: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.4734 16.5266H2.55389L13.4325 5.64802L12.352 4.56753L1.4734 15.4461V16.5266ZM16.5512 4.59209L13.4079 1.44884L14.4393 0.417462C14.7176 0.139154 15.0614 0 15.4707 0C15.8799 0 16.2237 0.139154 16.502 0.417462L17.5825 1.49795C17.8608 1.77626 18 2.12005 18 2.52933C18 2.93861 17.8608 3.2824 17.5825 3.56071L16.5512 4.59209ZM15.5198 5.62346L3.14325 18H0V14.8568L12.3765 2.48022L15.5198 5.62346ZM12.8922 5.10778L12.352 4.56753L13.4325 5.64802L12.8922 5.10778Z" fill="#434649" fillOpacity="0.85"/>
    </svg>
  </SvgWrapper>
);